import { ConstantVariables } from "../../Helpers/ConstantVariables";

export class AdminAIUsageManager {

    constructor(private containerElement: JQuery) { }

    private yearSelectList : JQuery<HTMLElement>;
    private monthSelectList : JQuery<HTMLElement>;
    private aiUsageContainer : JQuery<HTMLElement>;

    public initialize() {
        var self = this;

        self.yearSelectList = self.containerElement.find('#ai-usage-year-select');
        self.monthSelectList = self.containerElement.find('#ai-usage-month-select');
        self.aiUsageContainer = self.containerElement.find('#ai-usage-content');

        self.yearSelectList.off('change').on('change', () => {
            self.loadUsage();
        })        
        
        self.monthSelectList.off('change').on('change', () => {
            self.loadUsage();
        })

        self.loadUsage();
    }

    private loadUsage() {
        var self = this;

        var year = self.yearSelectList.val();
        var month = self.monthSelectList.val();

        //.html(ConstantVariables.SpinnerHtml)
        
        self.aiUsageContainer.load(`?year=${year}&month=${month}&handler=AiUsage`)
    }

}